var constants = require('../constants');
var initialState = require('../../initialState');

var education = function(state, action) {
    var newstate = Object.assign({}, state);
    switch (action.type) {
        case constants.REQUEST_EDUCATION:
            newstate.isFetching = true;
            newstate.didInvalidate = false;
            return newstate;
        case constants.RECEIVE_EDUCATION:
            newstate.isFetching = false;
            newstate.bodyparts = action.bodyparts;
            newstate.symptoms = action.symptoms;
            newstate.diseases = action.diseases;
            newstate.qols = action.qols;
            return newstate;
        case constants.SET_THANKS_REGISTERING_MESSAGE:
            newstate.thanksRegisteringMessage = action.thanksRegisteringMessage;
            return newstate;
        case constants.CLEAR_THANKS_REGISTERING_MESSAGE:
            newstate.thanksRegisteringMessage = '';
            return newstate;
        case constants.SHOW_THANKS_FOR_TAKING_SURVEY_BANNER:
            newstate.isShowThanksForTakingSurveyBanner = true;
            return newstate;
        case constants.HIDE_THANKS_FOR_TAKING_SURVEY_BANNER:
            newstate.isShowThanksForTakingSurveyBanner = false;
            return newstate;
        default:
            return state || initialState.education;
    }
}

module.exports = education;


// WEBPACK FOOTER //
// ./src/common/modules/education/reducers/education.js